import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const CATEGORY_MAP = {
  rings: "Rings",
  earrings: "Earrings",
  pendants: "Pendants",
  bracelets: "Bracelets",
  coins: "Coins",
  chains: "Chains",
  mangalsutra: "Mangalsutra",
  bangles: "Bangles",
  solitaires: "Solitaires",
  charms: "Charms",
};

export default function MetalCategoryGate({ metal: propMetal }) {
  const { categorySlug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const metalNorm = (propMetal || "gold").toLowerCase();
    const categoryName = CATEGORY_MAP[categorySlug?.toLowerCase()] || categorySlug;
    if (metalNorm === "coins" || categorySlug?.toLowerCase() === "coins") {
      navigate(`/shop?product_type=coin`, { replace: true });
    } else {
      navigate(`/shop?metal=${metalNorm}&category=${encodeURIComponent(categoryName)}`, { replace: true });
    }
  }, [propMetal, categorySlug, navigate]);

  return <div className="container-x py-20 text-center text-stone-400 font-mono text-sm">Loading collection…</div>;
}
